let localStorageAvailable = null;

export function checkLocalStorage() {
  // if (localStorageAvailable !== null) return localStorageAvailable;

  try {
    window.localStorage.setItem('test', 'test');
    window.localStorage.removeItem('test');

    localStorageAvailable = true;

    return true;
  } catch(e) {
    localStorageAvailable = false;

    return false;
  }
}

export function setItem(identifier, value) {
  localStorage.setItem(identifier, value);
}

export function getItem(identifier) {
  return localStorage.getItem(identifier);
}

export function clearItem(identifier) {
  localStorage.removeItem(identifier);
}

export default { checkLocalStorage, setItem, getItem, clearItem };
